import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import common_en from "./assets/translations/en.json";
import common_en_CA from "./assets/translations/en-CA.json";
import common_en_GR from "./assets/translations/en-GR.json";
import common_en_IN from "./assets/translations/en-IN.json";
import common_en_UK from "./assets/translations/en-UK.json";
import common_fr from "./assets/translations/fr.json";
import common_fr_BE from "./assets/translations/fr-BE.json";
import common_fr_CA from "./assets/translations/fr-CA.json";
import common_fr_GR from "./assets/translations/fr-GR.json";

let savedLanguage;
try {
    savedLanguage = JSON.parse(localStorage.getItem("settings") ?? "{}").accountSettings?.language;
} catch {
    savedLanguage = undefined;
}
const browserLanguage = navigator.language.startsWith("en") ? "en" : "fr";

i18n.use(initReactI18next).init({
    lng: savedLanguage || browserLanguage,
    fallbackLng: {
        "en-CA": ["en", "fr"],
        "en-GR": ["en"],
        "en-IN": ["en"],
        "en-UK": ["en"],
        "fr-CA": ["fr"],
        "fr-BE": ["fr"],
        "fr-GR": ["fr"],
        default: ["fr"],
    },
    debug: import.meta.env.DEV && import.meta.env.TEST !== "true" && window.location.host !== "manage.crealo.app",
    resources: {
        en: {
            translation: common_en,
        },
        "en-CA": {
            translation: common_en_CA,
        },
        "en-GR": {
            translation: common_en_GR,
        },
        "en-IN": {
            translation: common_en_IN,
        },
        "en-UK": {
            translation: common_en_UK,
        },
        fr: {
            translation: common_fr,
        },
        "fr-BE": {
            translation: common_fr_BE,
        },
        "fr-CA": {
            translation: common_fr_CA,
        },
        "fr-GR": {
            translation: common_fr_GR,
        },
    },
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
